import { render, staticRenderFns } from "./show.vue?vue&type=template&id=4dc09d36&scoped=true"
import script from "./show.vue?vue&type=script&setup=true&lang=js"
export * from "./show.vue?vue&type=script&setup=true&lang=js"
import style0 from "./show.vue?vue&type=style&index=0&id=4dc09d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc09d36",
  null
  
)

export default component.exports